export default function RelateCampaignModel(dict) {
    this.campaignId = dict.CampaignId;
    this.campaignName = dict.CampaignName;
    this.campaignPoints = dict.CampaignPoints;
    this.campaignPrice = dict.CampaignPrice;
    this.imageUrl = dict.ImageUrl;
    this.link = dict.Link;

    if (this.imageUrl) {
        if(this.imageUrl.indexOf("-large") < 0) {
            var newString = this.imageUrl.replace("?", "-large?");
            this.imageUrl = newString;
        }
    }
}
